/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerComplianceFileEntryResource
 */
export interface FreelancerComplianceFileEntryResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceFileEntryResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceFileEntryResource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceFileEntryResource
     */
    downloadLink?: string;
}

/**
 * Check if a given object implements the FreelancerComplianceFileEntryResource interface.
 */
export function instanceOfFreelancerComplianceFileEntryResource(value: object): value is FreelancerComplianceFileEntryResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FreelancerComplianceFileEntryResourceFromJSON(json: any): FreelancerComplianceFileEntryResource {
    return FreelancerComplianceFileEntryResourceFromJSONTyped(json, false);
}

export function FreelancerComplianceFileEntryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceFileEntryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'downloadLink': json['downloadLink'] == null ? undefined : json['downloadLink'],
    };
}

export function FreelancerComplianceFileEntryResourceToJSON(value?: FreelancerComplianceFileEntryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'downloadLink': value['downloadLink'],
    };
}

